/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServicePageItemRespVo
 */
export interface AdditionalServicePageItemRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    id?: number;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    name?: string;
    /**
     * 附加服务名称（中文）
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    nameCn?: string;
    /**
     * 附加服务编码
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    code?: string;
    /**
     * 附加服务价格
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    price?: number;
    /**
     * 附加服务组 ID，关联附加服务组表
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    groupId?: number;
    /**
     * 附加服务组名称
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    groupName?: string;
    /**
     * 附加服务组名称（中文）
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    groupNameCn?: string;
    /**
     * 图片 URL 的 JSON 数组，形如 ["","""]
     * @type {Array<string>}
     * @memberof AdditionalServicePageItemRespVo
     */
    imageUrls?: Array<string>;
    /**
     * 视频 URL 的 JSON 数组，形如 ["","""]
     * @type {Array<string>}
     * @memberof AdditionalServicePageItemRespVo
     */
    videoUrls?: Array<string>;
    /**
     * 排序
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    sort?: number;
    /**
     * 仓库 ID，关联仓库表
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    warehouseId?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    updateTime?: string;
    /**
     * 货币代码
     * @type {string}
     * @memberof AdditionalServicePageItemRespVo
     */
    currencyCode?: string;
    /**
     * 下单时是否显示 0 不显示， 1 显示
     * @type {number}
     * @memberof AdditionalServicePageItemRespVo
     */
    showOnOrder?: number;
}

/**
 * Check if a given object implements the AdditionalServicePageItemRespVo interface.
 */
export function instanceOfAdditionalServicePageItemRespVo(value: object): value is AdditionalServicePageItemRespVo {
    return true;
}

export function AdditionalServicePageItemRespVoFromJSON(json: any): AdditionalServicePageItemRespVo {
    return AdditionalServicePageItemRespVoFromJSONTyped(json, false);
}

export function AdditionalServicePageItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServicePageItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'code': json['code'] == null ? undefined : json['code'],
        'price': json['price'] == null ? undefined : json['price'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupNameCn': json['groupNameCn'] == null ? undefined : json['groupNameCn'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
        'videoUrls': json['videoUrls'] == null ? undefined : json['videoUrls'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'showOnOrder': json['showOnOrder'] == null ? undefined : json['showOnOrder'],
    };
}

export function AdditionalServicePageItemRespVoToJSON(json: any): AdditionalServicePageItemRespVo {
    return AdditionalServicePageItemRespVoToJSONTyped(json, false);
}

export function AdditionalServicePageItemRespVoToJSONTyped(value?: AdditionalServicePageItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'price': value['price'],
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'groupNameCn': value['groupNameCn'],
        'imageUrls': value['imageUrls'],
        'videoUrls': value['videoUrls'],
        'sort': value['sort'],
        'warehouseId': value['warehouseId'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'currencyCode': value['currencyCode'],
        'showOnOrder': value['showOnOrder'],
    };
}

